export type PdsStage =
  'new' | 'preparing' | 'ready' | 'handed' | 'cancelled' | 'refused';

export type PdsStageFilter = 'all' | 'new' | 'preparing' | 'ready';

export type PdsChannel = 'Click & Collect' | 'Sur place';

export interface PdsOrderItem {
  id: string;
  quantity: number;
  name: string;
  option?: string;
  prepared: boolean;
  // Instant où la ligne a été retirée de la commande ; absent tant qu'elle y est.
  removedAt?: number;
  // Prix unitaire payé, pour le ticket client ; absent quand le serveur ne l'a pas donné.
  unitPriceCents?: number;
}

export interface PdsContact {
  name?: string;
  phone?: string;
  email?: string;
}

export interface PdsOrder {
  id: string;
  number: number;
  // Numéro complet du serveur (« R01-2610-000114 ») ; absent des données fictives, où `number` fait foi.
  orderNumber?: string;
  label: string;
  contact: PdsContact;
  channel: PdsChannel;
  pickupCode: string;
  dueAt: number;
  stage: PdsStage;
  customerNote?: string;
  items: PdsOrderItem[];
  // Lignes retirées pendant la préparation : montrées à titre d'information, jamais comptées ni à préparer.
  removedItems?: PdsOrderItem[];
  totalPaidCents: number;
  readyAt?: number;
  handedAt?: number;
  refusal?: PdsRefusal;
  cancelledAt?: number;
  cancelAcknowledged?: boolean;
}

// Un retrait proposé pour un jour : l'heure d'un créneau, ou le début d'une plage.
// `available` faux : le créneau est complet, il reste affiché mais ne se choisit pas.
export interface PdsPickupChoice {
  at: number;
  label: string;
  available: boolean;
}

// Une ligne dont la quantité a baissé (ou qui a disparu, `to` à 0) lors d'une modification de la commande.
export interface PdsModificationLine {
  name: string;
  from: number;
  to: number;
  refundCents: number;
}

// Une modification de la commande par le commerce : ce qui a changé, pourquoi, et ce qui a été remboursé.
export interface PdsModification {
  id: string;
  at: number;
  reason?: string;
  refundCents: number;
  lines: PdsModificationLine[];
}

// Refus ou annulation par le commerce : les motifs cochés, et le texte libre que le client lit.
export interface PdsRefusal {
  reasons: string[];
  message?: string;
}

export interface PdsCancellation extends PdsRefusal {
  message: string;
}

// Longueur maximale, côté serveur, du motif et du message au client.
export const TEXT_MAX_LENGTH = 1000;

export const REFUSAL_REASONS = [
  'Produit indisponible',
  'Créneau intenable',
  'Demande du client',
  'Paiement non abouti',
  'Commerce fermé',
  'Sans motif',
] as const;

export const NO_REASON = 'Sans motif';
